import React, { Component } from 'react';
import * as styled from '../../../styles/style';
import * as variables from '../../../styles/variables';
import { invitationDateLabels } from '../../../helpers/enums';


class EmailPreview extends Component {
  render() {
    const { event, user } = this.props;

    let escapedMessage = event.invitation_message ? event.invitation_message.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';

    let eventTimeLine = '';
    if (event.invitation_end_time) {
      if (event.invitation_start_ampm === event.invitation_end_ampm) {
        eventTimeLine = event.invitation_start_time + ' - ' + event.invitation_end_time + ' ' + event.invitation_start_ampm;
      } else {
        eventTimeLine = event.invitation_start_time + ' ' + event.invitation_start_ampm + ' - ' + event.invitation_end_time + ' ' + event.invitation_end_ampm;
      }
    } else {
      eventTimeLine = event.invitation_start_time + ' ' + event.invitation_start_ampm;
    }

    return (
      <div className="invitation-preview" style={{padding: '20px', background: 'rgba(162,177,172,0.4)', borderRadius: '10px'}}>
        <p><strong>From:</strong> {user.firstname} {user.lastname} via On the Table BC</p>
        <p><strong>To:</strong> Your Guest</p>
        <p style={{marginBottom: '2em'}}><strong>Subject:</strong> You&apos;re invited to an On the Table BC event {invitationDateLabels[event.invitation_date]}th</p>
        <table cellPadding="0" cellSpacing="0" border="0" id="backgroundTable" style={{backgroundColor: '#ffffff', height: '100%', margin:'0', padding:'0', fontSize: '16px', lineHeight: '1.4', color: '#404040'}}>
          <tbody>
            <tr style={{background: '#F0F0F0'}}>
              <td>
                <img className="header-image" src={`${process.env.REACT_APP_BASE_URL}/api/image?food1=${event.food1}&food2=${event.food2}&topic=${event.topic}`} width="800" height="" height="400" border="0" style={{display: 'block', width: '100%', height: 'auto', maxWidth: '1600px', maxHeight: '800px'}} alt="" />
              </td>
            </tr>
            <tr>
              <td>
                <table className="main-container" cellPadding="0" cellSpacing="0" border="0" align="center" style={{width: '85%', margin: '0px auto'}}>
                  <tbody>
                    <tr style={{height: '20px'}}></tr>
                    <tr>
                      <td>
                        <table width="100%" cellPadding="0" cellSpacing="0" border="0" style={{backgroundColor: 'white'}}>
                          <tbody>
                            <tr>
                              <td style={{padding: '0px 20px 20px 20px', margin: '0px auto', textAlign: 'left'}}>

                                <p style={{marginBottom: '1em'}}>Dear [First Name],</p>
                                <p dangerouslySetInnerHTML={{__html: escapedMessage}} />

                                <hr style={{margin: '20px 0', border: '0', height: '1px', background: '#404040'}} />

                                <p style={{marginBottom: '1em'}}><strong>Event Details</strong></p>
                                <p style={{margin: '0'}}><strong>Date:</strong> {invitationDateLabels[event.invitation_date]}</p>
                                <p style={{margin: '0'}}><strong>Time:</strong> {eventTimeLine}</p>
                                <p style={{margin: '0'}}>
                                  <strong>Location: </strong>
                                  {event.address_description && ( event.address_description)} {event.address_1}, {event.city}, {event.province}
                                </p>
                                {event.extra_directions && (
                                  <p style={{margin: '0'}}><strong>Extra directions: </strong>{event.extra_directions}</p>
                                )}

                                <div style={{margin: '20px 0'}}>
                                <styled.InvitationButton className="invitation-button" color={variables.colours.orange}>Attending</styled.InvitationButton>
                                <styled.InvitationButton className="invitation-button" color={variables.colours.olive}>Cannot Attend</styled.InvitationButton>
                                </div>

                                {event.invitation_logo && (
                                  <p style={{fontStyle: 'italic', fontSize: '12px', color: '#737373', margin: '10px 0 10px'}}>Hosted by</p>
                                )}
                                <img style={{maxWidth: '150px', maxHeight: '250px'}} src={event.invitation_logo} />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr style={{height: '10px'}}></tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default EmailPreview
